module.exports = __webpack_public_path__ + "media/images/social-share-button/tumblr-4d59e5b74838fa10b52f5214d941c997.svg";